import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './Accordion.scss';
import { connect } from 'react-redux';
var Accordion = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Accordion, _Component);

  var _super = _createSuper(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderSections", function (sections) {
      return sections.map(function (section, index) {
        var style = {};
        var labelStyle = {};

        if (index === 0) {
          style = {
            borderRadius: '4px 4px 0 0'
          };
        }

        if (index === sections.length - 1) {
          style = {
            borderRadius: '0 0 4px 4px'
          };
          labelStyle = {
            borderBottom: 0
          };
        }

        return /*#__PURE__*/React.createElement("div", {
          className: styles.accordionTab,
          key: index,
          style: Object.assign(style, _this.props.tabStyle)
        }, /*#__PURE__*/React.createElement("input", {
          className: styles.accordionControl,
          type: "checkbox",
          id: section.id,
          name: section.id,
          checked: section.opened,
          onClick: _this.props.onClick ? _this.props.onClick : undefined
        }), /*#__PURE__*/React.createElement("label", {
          className: styles.accordionLabel,
          htmlFor: section.id,
          style: Object.assign(labelStyle, _this.props.labelStyle)
        }, typeof section.label === 'function' ? section.label() : section.label), /*#__PURE__*/React.createElement("div", {
          className: styles.accordionContent,
          style: _this.props.acccordionContentStyles
        }, section.content));
      });
    });

    return _this;
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.accordionWrap,
        style: this.props.style
      }, this.renderSections(this.props.sections));
    }
  }]);

  return Accordion;
}(Component)) || _class);
Accordion.defaultProps = {
  acccordionContentStyles: {},
  labelStyle: {},
  tabStyle: {},
  style: {}
};
export default Accordion;